import { FC, memo, useMemo } from 'react';
import styled from 'styled-components';

import { useCurrentUser } from '@redux/selectors/users';
import { MIN_VISIBLE_SCORE } from '@utils/constants';
import { Score } from '@components/header/Score';
import theme from 'theme';

const Container = styled.div``;

const StyledScore = styled(Score)<{
  $size: string;
}>`
  font-size: ${({ $size }) => $size};
`;

type Props = {
  userId: string;
  value?: number;
  size?: string;
  className?: string;
};

const UserScore: FC<Props> = ({
  userId,
  value = 0,
  size = theme.fonts.fontSize['3xl'],
  className,
}) => {
  const currentUser = useCurrentUser();
  const isMe = useMemo(
    () => !!currentUser?.id && currentUser?.id === userId,
    [currentUser?.id, userId],
  );

  return isMe || value >= MIN_VISIBLE_SCORE ? (
    <Container className={className}>
      <StyledScore data-text={String(Math.round(value))} $size={size}>
        {Math.round(value)}
      </StyledScore>
    </Container>
  ) : null;
};

export default memo(UserScore);
